import React, { useState, useEffect, useRef, useId } from "react";
import "./BottomPanel.scss"; // Import the CSS file

export interface IBottomPanelProps {
  customComponent?: any;
  setShowSection?:any;
}
const BottomPanel = (props: IBottomPanelProps) => {
  const [isOpen, setIsOpen] = useState(true); // Automatically opens on load
  const panelRef = useRef<HTMLDivElement>(null);
  const previouslyFocused = useRef<HTMLElement | null>(null);
  const titleId = useId();

  // Close panel when clicking outside (overlay)
  const handleOverlayClick = () => {
    setIsOpen(false);
    props?.setShowSection(false)
  };

  const FOCUSABLE =
    'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  useEffect(() => {
    if (!isOpen) return;
    previouslyFocused.current = document.activeElement as HTMLElement;
    const closeBtn = panelRef.current?.querySelector<HTMLElement>(".close-btn");
    closeBtn?.focus();

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        handleOverlayClick();
        return;
      }
      if (e.key !== "Tab" || !panelRef.current) return;
      const focusable = Array.from(
        panelRef.current.querySelectorAll<HTMLElement>(FOCUSABLE)
      ).filter((el) => el.offsetParent !== null || el === document.activeElement);
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first || !panelRef.current.contains(document.activeElement)) {
          e.preventDefault();
          last.focus();
        }
      } else if (document.activeElement === last || !panelRef.current.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      previouslyFocused.current?.focus?.();
    };
  }, [isOpen]);

  return (
    <div>
      {/* Overlay (Backdrop) */}
      <div
        className={`overlay ${isOpen ? "show" : ""}`}
        onClick={() => {
       //   setIsOpen(false);
          handleOverlayClick();
        }}
        aria-hidden="true"
      ></div>

      {/* Bottom Panel Content */}
      <div
        className={`bottom-panel ${isOpen ? "open" : ""}`}
        ref={panelRef}
        role="dialog"
        aria-modal="true"
       aria-labelledby={titleId}
        hidden={!isOpen}
      >
        <h2 id={titleId} className="sr-only">Panel</h2>
        {/* Drag Handle */}
        <button
          type="button"
          className="drag-handle"
          onClick={() => {
         
            handleOverlayClick();
          }}
         aria-label="Close panel"
        ></button>

        {/* Close Button */}
        <button
          className="close-btn"
          type="button"
          aria-label="Close"
          onClick={() => {
            //setIsOpen(false);
            handleOverlayClick();
          }}
        >
          ✕
        </button>

        {/* Content */}
        {props?.customComponent()}
        {/* <h2>Bottom Panel</h2>
        <p>This panel opens automatically and works on all mobile screens.</p> */}
      </div>
    </div>
  );
};

export default BottomPanel;
